const socialGroups = {
  f1: 'F1 - High-Income Urban Fringe',
  f2: 'F2 - Diverse Urban Fringe',
  f3: 'F3 - Middle-Income Urban Fringe',
  r1: 'R1 - Upper-Middle Rural',
  r2: 'R2 - Lower-Middle Rural',
  r3: 'R3 - Rural Francophone',
  s1: 'S1 - Suburban Elite',
  s2: 'S2 - High-Income Suburban Diversity',
  s3: 'S3 - Upper-Middle Suburbia',
  s4: 'S4 - High-Income Suburban Francophone',
  s6: 'S6 - Older Suburban',
  s5: 'S5 - Middle-Income Suburbia',
  s7: 'S7 - Lower-Middle Suburban Francophone',
  t1: 'T1 - Town Mix',
  u1: 'U1 - Urban Elite',
  u2: 'U2 - Urban Older',
  u3: 'U3 - Young Urban Core',
  u4: 'U4 - Urban Diversity',
  u5: 'U5 - Younger Urban Mix',
  u6: 'U6 - Older Urban Francophone',
};

const lifeStages = {
  f1: 'F1 - School-Age Families',
  f2: 'F2 - Large Diverse Families',
  f3: 'F3 - Middle-Age Families',
  m1: 'M1 - Older Families & Empty Nests',
  m2: 'M2 - Mature Singles & Couples',
  y1: 'Y1 - Very Young Singles & Couples',
  y2: 'Y2 - Younger Singles & Couples',
  y3: 'Y3 - Young Families',
};

const colors = {
  rural: '#0D8482',
  suburbanElite: '#F47A20',
  town: '#A3BB39',
  urban: '#DD332A',
  urbanFringe: '#E6AB21',
};

const segmentDetails = [
  {
    code: '01',
    color: colors.urban,
    socialGroup: socialGroups.u1,
    lifeStage: lifeStages.m1,
  },
  {
    code: '02',
    color: colors.urban,
    socialGroup: socialGroups.u1,
    lifeStage: lifeStages.m1,
  },
  {
    code: '03',
    color: colors.urbanFringe,
    socialGroup: socialGroups.f1,
    lifeStage: lifeStages.f2,
  },
  {
    code: '04',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s1,
    lifeStage: lifeStages.f3,
  },
  {
    code: '05',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s1,
    lifeStage: lifeStages.f2,
  },
  {
    code: '06',
    color: colors.urban,
    socialGroup: socialGroups.u1,
    lifeStage: lifeStages.f1,
  },
  {
    code: '07',
    color: colors.urbanFringe,
    socialGroup: socialGroups.f1,
    lifeStage: lifeStages.m1,
  },
  {
    code: '08',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s2,
    lifeStage: lifeStages.f2,
  },
  {
    code: '09',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s1,
    lifeStage: lifeStages.m1,
  },
  {
    code: '10',
    color: colors.urbanFringe,
    socialGroup: socialGroups.f2,
    lifeStage: lifeStages.f2,
  },
  {
    code: '11',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s2,
    lifeStage: lifeStages.f2,
  },
  {
    code: '12',
    color: colors.urban,
    socialGroup: socialGroups.u3,
    lifeStage: lifeStages.y1,
  },
  {
    code: '13',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s4,
    lifeStage: lifeStages.f2,
  },
  {
    code: '14',
    color: colors.rural,
    socialGroup: socialGroups.r1,
    lifeStage: lifeStages.f3,
  },
  {
    code: '15',
    color: colors.urban,
    socialGroup: socialGroups.u4,
    lifeStage: lifeStages.f2,
  },
  {
    code: '16',
    color: colors.urban,
    socialGroup: socialGroups.u2,
    lifeStage: lifeStages.m1,
  },
  {
    code: '17',
    color: colors.urban,
    socialGroup: socialGroups.u4,
    lifeStage: lifeStages.f3,
  },
  {
    code: '18',
    color: colors.urbanFringe,
    socialGroup: socialGroups.f1,
    lifeStage: lifeStages.f2,
  },
  {
    code: '19',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s3,
    lifeStage: lifeStages.f3,
  },
  {
    code: '20',
    color: colors.urbanFringe,
    socialGroup: socialGroups.f2,
    lifeStage: lifeStages.y2,
  },
  {
    code: '21',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s6,
    lifeStage: lifeStages.m2,
  },
  {
    code: '22',
    color: colors.urban,
    socialGroup: socialGroups.u3,
    lifeStage: lifeStages.y2,
  },
  {
    code: '23',
    color: colors.urban,
    socialGroup: socialGroups.u2,
    lifeStage: lifeStages.m1,
  },
  {
    code: '24',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s3,
    lifeStage: lifeStages.y3,
  },
  {
    code: '25',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s3,
    lifeStage: lifeStages.f3,
  },
  {
    code: '26',
    color: colors.rural,
    socialGroup: socialGroups.r1,
    lifeStage: lifeStages.f3,
  },
  {
    code: '27',
    color: colors.urbanFringe,
    socialGroup: socialGroups.f2,
    lifeStage: lifeStages.f3,
  },
  {
    code: '28',
    color: colors.urban,
    socialGroup: socialGroups.u5,
    lifeStage: lifeStages.y1,
  },
  {
    code: '29',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s4,
    lifeStage: lifeStages.f3,
  },
  {
    code: '30',
    color: colors.urbanFringe,
    socialGroup: socialGroups.f3,
    lifeStage: lifeStages.f2,
  },
  {
    code: '31',
    color: colors.urbanFringe,
    socialGroup: socialGroups.f3,
    lifeStage: lifeStages.f3,
  },
  {
    code: '32',
    color: colors.urbanFringe,
    socialGroup: socialGroups.f3,
    lifeStage: lifeStages.f1,
  },
  {
    code: '33',
    color: colors.rural,
    socialGroup: socialGroups.r1,
    lifeStage: lifeStages.f3,
  },
  {
    code: '34',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s4,
    lifeStage: lifeStages.f3,
  },
  {
    code: '35',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s7,
    lifeStage: lifeStages.m1,
  },
  {
    code: '36',
    color: colors.urban,
    socialGroup: socialGroups.u2,
    lifeStage: lifeStages.f3,
  },
  {
    code: '37',
    color: colors.town,
    socialGroup: socialGroups.t1,
    lifeStage: lifeStages.f1,
  },
  {
    code: '38',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s5,
    lifeStage: lifeStages.f3,
  },
  {
    code: '39',
    color: colors.urban,
    socialGroup: socialGroups.u6,
    lifeStage: lifeStages.f1,
  },
  {
    code: '40',
    color: colors.urban,
    socialGroup: socialGroups.u3,
    lifeStage: lifeStages.y1,
  },
  {
    code: '41',
    color: colors.rural,
    socialGroup: socialGroups.r2,
    lifeStage: lifeStages.m1,
  },
  {
    code: '42',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s7,
    lifeStage: lifeStages.f1,
  },
  {
    code: '43',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s5,
    lifeStage: lifeStages.f3,
  },
  {
    code: '44',
    color: colors.urban,
    socialGroup: socialGroups.u6,
    lifeStage: lifeStages.m2,
  },
  {
    code: '45',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s6,
    lifeStage: lifeStages.m1,
  },
  {
    code: '46',
    color: colors.rural,
    socialGroup: socialGroups.r3,
    lifeStage: lifeStages.m1,
  },
  {
    code: '47',
    color: colors.urban,
    socialGroup: socialGroups.u3,
    lifeStage: lifeStages.y1,
  },
  {
    code: '48',
    color: colors.rural,
    socialGroup: socialGroups.r2,
    lifeStage: lifeStages.f3,
  },
  {
    code: '49',
    color: colors.rural,
    socialGroup: socialGroups.r2,
    lifeStage: lifeStages.m2,
  },
  {
    code: '50',
    color: colors.rural,
    socialGroup: socialGroups.r2,
    lifeStage: lifeStages.m2,
  },
  {
    code: '51',
    color: colors.urban,
    socialGroup: socialGroups.u2,
    lifeStage: lifeStages.m2,
  },
  {
    code: '52',
    color: colors.urban,
    socialGroup: socialGroups.u5,
    lifeStage: lifeStages.y2,
  },
  {
    code: '53',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s6,
    lifeStage: lifeStages.m2,
  },
  {
    code: '54',
    color: colors.rural,
    socialGroup: socialGroups.r3,
    lifeStage: lifeStages.f3,
  },
  {
    code: '55',
    color: colors.urban,
    socialGroup: socialGroups.u3,
    lifeStage: lifeStages.f1,
  },
  {
    code: '56',
    color: colors.urban,
    socialGroup: socialGroups.u6,
    lifeStage: lifeStages.y2,
  },
  {
    code: '57',
    color: colors.urban,
    socialGroup: socialGroups.u5,
    lifeStage: lifeStages.y2,
  },
  {
    code: '58',
    color: colors.town,
    socialGroup: socialGroups.t1,
    lifeStage: lifeStages.m1,
  },
  {
    code: '59',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s7,
    lifeStage: lifeStages.f1,
  },
  {
    code: '60',
    color: colors.urban,
    socialGroup: socialGroups.u5,
    lifeStage: lifeStages.f1,
  },
  {
    code: '61',
    color: colors.urban,
    socialGroup: socialGroups.u4,
    lifeStage: lifeStages.f3,
  },
  {
    code: '62',
    color: colors.suburbanElite,
    socialGroup: socialGroups.s6,
    lifeStage: lifeStages.m2,
  },
  {
    code: '63',
    color: colors.rural,
    socialGroup: socialGroups.r3,
    lifeStage: lifeStages.m1,
  },
  {
    code: '64',
    color: colors.urban,
    socialGroup: socialGroups.u4,
    lifeStage: lifeStages.f3,
  },
  {
    code: '65',
    color: colors.urban,
    socialGroup: socialGroups.u6,
    lifeStage: lifeStages.m2,
  },
  {
    code: '66',
    color: colors.town,
    socialGroup: socialGroups.t1,
    lifeStage: lifeStages.f2,
  },
  {
    code: '67',
    color: colors.urban,
    socialGroup: socialGroups.u5,
    lifeStage: lifeStages.y2,
  },
];

const PrizmData = {
  lifeStages,
  socialGroups,
  segmentDetails,
};

export default PrizmData;
